"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Intro = _interopRequireDefault(require("../screens/Intro"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Intro = ({
  disableSocialLogin,
  onGoogleLogin,
  onFacebookLogin,
  onAppleLogin,
  onChangeScreen,
  googleError,
  facebookError,
  customTitle,
  customDescription
}) => {
  const {
    log
  } = (0, _context.useLog)();
  React.useEffect(() => {
    log(_events.INTRO_SCREEN_SHOWN, {});
  }, [log]);
  const handleIncorrectEmail = () => {
    log(_events.GET_SIMPLE_TOKEN, {});
    onChangeScreen("getSingleBooking");
  };
  const handleEmailLogin = () => {
    log(_events.CONTINUE_WITH_EMAIL, {});
    onChangeScreen("emailLogin");
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Intro.default, {
    customTitle: customTitle,
    customDescription: customDescription,
    disableSocialLogin: disableSocialLogin,
    onAppleLogin: onAppleLogin,
    onEmailLogin: handleEmailLogin,
    onGoogleLogin: onGoogleLogin,
    onFacebookLogin: onFacebookLogin,
    onIncorrectEmail: handleIncorrectEmail,
    googleError: googleError,
    facebookError: facebookError
  });
};
var _default = Intro;
exports.default = _default;